import axiosInstance from '../axiosInterceptor/axiosInstance'

// An event of the org, whatever its type: the game or the practice it is.
const getEvent = async (data) => {
  const { eventId, orgId } = data
  const url = `v1/orgs/${orgId}/events/${eventId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getEvent
